import { render, staticRenderFns } from "./wrongWordStatisticsDetail.vue?vue&type=template&id=d85735f2&scoped=true&"
import script from "./wrongWordStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./wrongWordStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./wrongWordStatisticsDetail.vue?vue&type=style&index=0&id=d85735f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85735f2",
  null
  
)

export default component.exports